"use client"
import { useRouter } from "next/router";
import React, { useEffect, useState } from 'react';
import Ad from 'src/components/ads/Ad';
import Button from 'src/components/button/Button';
import TrailerOverlayWrapper from 'src/components/traileroverlaywrapper/TrailerOverlayWrapper';
import styled from 'src/lib/styles/css';

//#region [Props]
type TrailerPosterListExpanderProps = {
	children: React.ReactNode;
};
//#endregion

const trailerIdRegex = /#trailer(\d+)/;

//#region [Component]
export default function TrailerPosterListExpander({ children }: TrailerPosterListExpanderProps) {
	const [isExpanded, setIsExpanded] = useState(false);
	const [trailerId, setTrailerId] = useState<number | null>(null);
	const childArray = React.Children.toArray(children);
	const router = useRouter();

	useEffect(() => {
		const listener = (ev: HashChangeEvent) => {
			const match = trailerIdRegex.exec(ev.newURL);
			if ((match?.length ?? 0) >= 1) {
				setTrailerId(Number(match![1]));
			}
		};

		window.addEventListener("hashchange", listener);
		// check if the already have a hash
		const match = trailerIdRegex.exec(router.asPath);
		if ((match?.length ?? 0) >= 1) {
			setTrailerId(Number(match![1]));
		}
		return () => {
			window.removeEventListener("hashchange", listener);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		let currentTrailerId: null | number = null;
		const match = trailerIdRegex.exec(router.asPath);
		if ((match?.length ?? 0) >= 1) {
			currentTrailerId = Number(match![1]);
		}
		if (trailerId !== null && trailerId !== currentTrailerId) {
			if (trailerId === 0) {
				router.replace(router.pathname, undefined, { shallow: true });
			} else {
				router.replace(router.pathname + "#trailer" + trailerId, undefined, { shallow: true });
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [trailerId]);

	return <>
		{childArray.slice(0, 18).map((child, idx) => <React.Fragment key={idx}>{child}</React.Fragment>)}
		<STopAd targetId='FW_topp_trailerseksjon' />
		{!isExpanded && <SButton onClick={() => setIsExpanded(true)} text="Flere trailere" />}
		{isExpanded && <>
			<SMidContentAd targetId='FW_midt3_trailerseksjon' />
			{childArray.slice(18).map((child, idx) => <React.Fragment key={`EX_${idx}`}>{child}</React.Fragment>)}
		</>}

		{trailerId && <TrailerOverlayWrapper videoId={trailerId!} onClose={() => setTrailerId(0)} onSelectTrailer={(newTrailerId) => setTrailerId(newTrailerId)} />}
	</>;
}
//#endregion

//#region [Styles]
const SButton = styled(Button)`
	justify-self: center;
	grid-column: 1 / -1;
`;

const SAdRow = styled(Ad)`
	width: 100%;
	grid-column: 1 / -1;
	@media (max-width: 549px) {
		margin-left: -10px;
		margin-right: -10px;
		width: 100vw;
	}

`;

const STopAd = styled(SAdRow)`
	grid-row: 2 / span 1;
`;

const SMidContentAd = styled(SAdRow)`
	grid-row: 6 / span 1;
`;
//#endregion